module.exports = __webpack_public_path__ + "img/header.8a0976bc.png";